// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCcnLcX8iykfy9Z8k5Wj-cQwn_x3UgTR4g",
  authDomain: "wimule-55119.firebaseapp.com",
  databaseURL:
    "https://wimule-55119-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "wimule-55119",
  storageBucket: "wimule-55119.appspot.com",
  messagingSenderId: "300596395221",
  appId: "1:300596395221:web:5edc45e59a35291208f65c",
  measurementId: "G-SXZKCH59JL",
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);
getAnalytics(firebase);
export const auth = getAuth(firebase);

export default firebase;
